import { Field, Widget } from '@kanda-libs/ks-component-ts';
import { BASE_ITEM, DESCRIPTION_VALIDATION } from './constants';

const EnquiryWorkDetailsFormFieldsWorkDescription: React.FunctionComponent =
  function () {
    return (
      <Widget.JobInfoJobItemsArrayWrapper initialData={[BASE_ITEM]}>
        {({ fields }) =>
          fields.map(({ id }, index) => (
            <Field.Array.Input key={id} index={index} name="title">
              <Field.Validator validation={DESCRIPTION_VALIDATION}>
                <Field.TextAreaInput
                  label="Provide a brief description of the work needed (optional)"
                  placeholder="This can us provide a more accurate quote"
                />
              </Field.Validator>
            </Field.Array.Input>
          ))
        }
      </Widget.JobInfoJobItemsArrayWrapper>
    );
  };

export default EnquiryWorkDetailsFormFieldsWorkDescription;
